import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import ConfigContext from "./context";
import { useHandler } from '../hooks';
import Iframe from "../iframe";

var ConfigProvider = function ConfigProvider(_ref) {
  var children = _ref.children,
      components = _ref.components,
      onClick = _ref.onClick,
      onImpression = _ref.onImpression;
  var clickHandler = useHandler(onClick);
  var impressionHandler = useHandler(onImpression);
  var value = useMemo(function () {
    return {
      components: Object.assign(Object.assign({}, components), {
        Iframe: Iframe
      }),
      onClick: clickHandler,
      onImpression: impressionHandler
    };
  }, [components, clickHandler, impressionHandler]);
  return _jsx(ConfigContext.Provider, Object.assign({
    value: value
  }, {
    children: children
  }));
};

ConfigProvider.displayName = 'CoreConfigProvider';
export default ConfigProvider;